export interface IRolePermissions {
  settings: SettingsPermissions;
  newsFeed: NewsFeedPermissions;
  videoConference: VideoConferencePermissions;
  messaging: MessagingPermissions;
  teamAndChannel: TeamAndChannelPermissions;
  userManagement: UserManagementPermissions;
  admin: AdminPermissions;
}

export enum PermissionType {
  SETTINGS_PERMISSIONS,
  NEWS_FEED_PERMISSIONS,
  VIDEO_CONFERENCE_PERMISSIONS,
  MESSAGING_PERMISSIONS,
  TEAM_AND_CHANNEL_PERMISSIONS,
  USER_MANAGEMENT_PERMISSIONS,
  ADMIN_PERMISSIONS,
}

export enum SettingsPermissions {
  UPDATE_SYSTEM_SETTINGS = 1 << 0, //46
  UPDATE_PASSWORD_SETTINGS = 1 << 1, //47
  UPDATE_EMAIL_SETTINGS = 1 << 2, //48
  UPDATE_LDAP_SETTINGS = 1 << 3, //49
  VIEW_DASHBOARD = 1 << 4, //50
  EXPORT_DASHBOARD = 1 << 5, //51,
  CREATE_UPDATE_ROLES = 1 << 6,
  //NEW
  VIEW_SYSTEM_SETTINGS = 1 << 7,
  VIEW_PASSWORD_SETTINGS = 1 << 8,
  VIEW_EMAIL_SETTINGS = 1 << 9,
  VIEW_LDAP_SETTINGS = 1 << 10,
  VIEW_ROLE_SETTINGS = 1 << 11,
}

export enum NewsFeedPermissions {
  CREATE_NEWSFEED = 1 << 0, //33
  VIEW_NEWSFEED = 1 << 1, //34
  NEWSFEED_FILE_SHARE = 1 << 2, //35
  EDIT_DELETE_NEWSFEED = 1 << 3, //36
  COMMENT_LIKE_NEWSFEED = 1 << 4 //37
}

export enum VideoConferencePermissions {
  CREATE_EDIT_MEETING = 1 << 0, //29
  VIEW_ALL_MEETING_LIST = 1 << 1, //30
  VIEW_JOIN_MEETING = 1 << 2 //31
}

export enum MessagingPermissions {
  SEARCH_ALL_MESSAGES = 1 << 0, //21
  START_MESSAGING = 1 << 1, //22
  START_OTR_MESSAGING = 1 << 2, //23
  DOCUMENT_SHARE = 1 << 3, //24
  IMAGE_VIDEO_SHARE = 1 << 4, //25
  AUDIO_SHARE = 1 << 5, //26
  CREATE_MEETING_IN_MESSAGE = 1 << 6 //27
}

export enum TeamAndChannelPermissions {
  REMOVE_TEAM_FROM_ARCHIVE = 1 << 0,
  UPDATE_TEAM = 1 << 1,
  UPDATE_CHANNEL = 1 << 2,
  CREATE_MEETING_IN_CHANNEL = 1 << 3,
  VIEW_TEAM_MEMBERS = 1 << 4,
  VIEW_TEAM_STATISTICS = 1 << 5,
  SEARCH_PUBLIC_CHANNEL = 1 << 6,
  VIEW_MEMBERSHIPS = 1 << 7,
  VIEW_TEAMS = 1 << 8,
  //NEW
  VIEW_TEAM_SETTINGS = 1 << 9,
  VIEW_CHANNEL_SETTINGS = 1 << 10,
  CREATE_TEAM = 1 << 11,
  ARCHIVE_TEAM = 1 << 12,
  CREATE_CHANNEL = 1 << 13,
  ARCHIVE_CHANNEL_SETTINGS = 1 << 14
}

export enum UserManagementPermissions {
  UPDATE_USER = 1 << 0,
  CREATE_AND_ARCHIVE_USER = 1 << 1,
  VIEW_USER_STATISTICS = 1 << 2,
  MAKE_USER_POST_CREATOR = 1 << 3,
  VIEW_USER_SETTINGS = 1 << 4
}

export enum AdminPermissions {
	VIEW_ALL_NEWSFEED = 1 << 0, 
	VIEW_ALL_NEWSFEED_COMMENTS = 1 << 1, 
	EDIT_DELETE_ALL_NEWSFEED = 1 << 2,
	EDIT_DELETE_ALL_NEWSFEED_COMMENTS = 1 << 3, 
	VIEW_ALL_ROLES = 1 << 4, 
	EDIT_DELETE_ALL_ROLES = 1 << 5,
  UPDATE_USER = 1 << 6,
	VIEW_USER_TEAMS = 1 << 7,
	VIEW_USER_ROLES = 1 << 8, 
  INSERT_IMPORT_USERS = 1 << 9,
	UPDATE_USER_PASSWORD = 1 << 10,

}
